import { GET, POST, POST_DOWNLOAD } from './core';

export const deactivateAccounts = (token, deactivationList) => {
  return POST('/account/deactivate', { deactivationList }, token);
};

export const reactivateAccounts = (token, accountIds) => {
  return POST('/account/reactivate', { accountIds }, token);
};

export const searchAccounts = (token, payload) => {
  return POST('/account/search', payload, token);
};


export const downloadAccounts = (token, payload) => {
  return POST_DOWNLOAD('/account/search/download', payload, token);
};

export const getAccountStatus = (token, mobileNo) => {
  return GET(`/account/status/${mobileNo}`, token);
};
